// extracted by mini-css-extract-plugin
export default {"container":"OTibze7lrBIk8qYCNaJq","list":"fbiNmCy1_CkbbnjXh8hC","list-item":"qXrISLPmxZXl_VYt0HZ9","listItem":"qXrISLPmxZXl_VYt0HZ9"};